(() => {
  const page = document.querySelector('[data-new-entry-list]');
  if (!page) return;
  const privateSession = window.NubsSessionState.privateScope(page);
  const fetch = (...args) => privateSession.fetch(...args);

  const bridge = String(page.dataset.bridgeUrl || 'https://members.nubsmedia.ca').replace(/\/$/, '');
  const loading = page.querySelector('[data-new-entry-list-loading]');
  const errorBox = page.querySelector('[data-new-entry-list-error]');
  const items = page.querySelector('[data-new-entry-list-items]');
  const success = page.querySelector('[data-new-entry-list-success]');

  const make = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };

  const submitted = new URLSearchParams(location.search).get('submitted');
  if (submitted) {
    success.hidden = false;
    success.textContent = `New entry request ${submitted} was submitted successfully.`;
  }

  const fmt = (value) => {
    if (!value) return 'Unknown time';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString([], {dateStyle:'medium', timeStyle:'short'});
  };

  const releaseUrl = (request) => {
    const catalogId = String(request?.catalogId || request?.createdCatalogId || '').trim();
    const title = String(request?.title || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const number = catalogId.replace(/^NMREL-/i, '').trim();
    return title && /^\d+$/.test(number) ? `/community/release/${encodeURIComponent(title)}-nmrel-${encodeURIComponent(number)}` : '';
  };

  (async () => {
    try {
      const response = await fetch(`${bridge}/bridge/new-entry?mode=list`, {credentials:'include', cache:'no-store'});
      const body = await response.json().catch(() => null);
      if (!response.ok || !body?.ok) throw new Error(body?.error || `Request failed (${response.status}).`);

      loading.hidden = true;
      items.hidden = false;
      if (!body.requests?.length) {
        items.append(make('div', 'nubs-new-entry-list__status', 'You have not submitted any new database entries yet.'));
        return;
      }

      body.requests.forEach((request) => {
        const card = make('article', 'nubs-new-entry-list__card');
        const top = make('div', 'nubs-new-entry-list__card-top');
        const info = make('div');
        const title = make('strong', '');
        const href = releaseUrl(request);
        if (href) {
          const link = make('a', 'nubs-new-entry-list__release-link', request.title || 'Database release');
          link.href = href;
          title.append(link);
        } else {
          title.textContent = request.title || 'Database release';
        }
        info.append(title);

        const meta = [];
        if (request.catalogId || request.createdCatalogId) meta.push(request.catalogId || request.createdCatalogId);
        if (request.upc) {
          const count = String(request.upc).split(/[\n,;]+/).map((value) => value.trim()).filter(Boolean).length;
          meta.push(`${count > 1 ? 'UPCs' : 'UPC'} ${request.upc}`);
        }
        meta.push(fmt(request.submittedAt || request.appliedAt));
        info.append(make('p', 'nubs-new-entry-list__meta', meta.filter(Boolean).join(' · ')));

        const status = request.status === 'approved'
          ? 'Approved'
          : request.status === 'rejected'
            ? 'Not approved'
            : request.status === 'apply_failed'
              ? 'Needs administrator attention'
              : 'Pending review';
        top.append(info, make('span', 'nubs-new-entry-list__badge', status));
        card.append(top);
        if (request.reviewNote) card.append(make('p', 'nubs-new-entry-list__note', `Review note: ${request.reviewNote}`));
        items.append(card);
      });

      window.NubsListPagination?.attach(items, {
        itemSelector: ':scope > .nubs-new-entry-list__card',
        pageSize: 20,
        queryParam: 'new_entry_page',
        label: 'New entry request pages',
      });
    } catch (error) {
      loading.hidden = true;
      errorBox.hidden = false;
      errorBox.textContent = error.message || 'Unable to load your new-entry requests.';
    }
  })();
})();
